"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  desktop: {
    task: {
      inMorning: '凌晨_EN',
      morning: '上午_EN',
      noon: '中午_EN',
      afternoon: '中午_EN',
      evening: '晚上EN',
      good: '好_En',
      year: '年_EN',
      month: '月_EN',
      day: '号_EN',
      todayAll: 'To-do Tasks'
    },
    person: {
      personal: 'Personal center',
      position: 'Position',
      number: '次数_EN',
      login: 'Login',
      office: 'Organization',
      Authorized: 'My Authorization',
      attionShip: 'My Fleet',
      collect: 'My Favorite'
    },
    vessel: {
      total: 'Single Ship Business Overview (Building)',
      singleShip: 'Single Ship Portrait'
    },
    msg: {
      remind: 'Message Reminder'
    },
    chart: {
      vesselChart: 'Statistical Analysis of Ships(Building)',
      shipPerformance: 'Ship Performance',
      checkBoard: 'Checking Statistics on Board',
      budgetReport: 'Annual Budget and \nActual Performance Report',
      unitNum: 'unit: number',
      unitTenThousandYuan: 'unit: ten thousand yuan',
      budget: 'budget',
      actual: 'actual',
      January: 'Jan',
      February: 'Feb',
      March: 'Mar',
      April: 'Apr',
      May: 'May',
      June: 'June',
      July: 'July',
      August: 'Aug',
      September: 'Sept',
      October: 'Oct',
      November: 'Nov',
      December: 'Dec',
      security: 'Security',
      shipNum: 'form:',
      ships: 'business ships；'
    },
    msgRead: {
      read: '消息待阅_EN'
    },
    file: {
      fileRead: 'File Reference'
    },
    monitor: {
      monitor: 'Monitor Reminder'
    }
  }
};